import { handleErrorDialog, showProgressDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { useAlertStorageClient, useAlertUiTranslation } from '../../../../hooks';
import { FormComponent } from '../AlertWizard/Components/FormComponent';
import { useReviewStep } from '../AlertWizard/WizardSteps/useReviewStep';
export const AlertReviewForm = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const alertStorageClient = useAlertStorageClient();
    const { t } = useAlertUiTranslation();
    const handleSendAlert = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (alertToSave) => {
        return alertStorageClient.validate(Object.assign(Object.assign({}, alertToSave), { permissions: [] })).then(() => alertStorageClient.sendAlert(alertToSave));
    }, [alertStorageClient]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSendAlert = (alertToSave) => {
        showProgressDialog({
            title: t('pages.summary.sendingNotification'),
            callback: (done) => {
                handleSendAlert(alertToSave)
                    .then((response) => {
                    done();
                    props.onSubmitSuccess(response);
                })
                    .catch((error) => {
                    done();
                    handleErrorDialog(error);
                });
            },
        });
    };
    const reviewStep = useReviewStep(props.mode, props.onBackToEdit, onSendAlert, props.onSaveTemplate, (_a = props.data) === null || _a === void 0 ? void 0 : _a.phin, ((_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.icon) || ((_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.color) ? { icon: (_d = props.data) === null || _d === void 0 ? void 0 : _d.icon, color: (_e = props.data) === null || _e === void 0 ? void 0 : _e.color } : undefined, (_f = props.data) === null || _f === void 0 ? void 0 : _f.followUp, props.generateUniqueIdentifier, (_g = props.data) === null || _g === void 0 ? void 0 : _g.totalRecipients);
    return reviewStep.form ? (React.createElement(FormComponent, { form: reviewStep.form, data: props.data, onSubmitSuccess: props.onSubmitSuccess, hideFormControls: true })) : null;
};
